export default "__VITE_ASSET__CUO8m6dG__"